<script>
import { computed, defineComponent } from 'vue'
import { useRoute } from 'vue-router'
import { collapsed } from './state'
// import { IonIcon } from '@ionic/vue';
// import { rocket } from 'ionicons/icons';


export default defineComponent ({
  components: { 
    // IonIcon
   },
  props: {
    to: { type: String, required: true},
    icon: { type: String, required: true},
    site: { type: String, default: ''}
  },
  setup(props) {
    const route = useRoute()
    const isActive = computed(()=>  route.path === props.to )

    return { isActive, collapsed }
  }
})
</script>
<template>
  <router-link :to="to" class="link" :class="[ site, { active: isActive } ]">
    <ion-icon class="icon" :name="icon"></ion-icon>
    <transition name="fade">
      <span v-if="!collapsed"><slot /></span>
    </transition>
  </router-link>
  <!-- <router-link to="/about">About</router-link> -->
</template>
<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.1s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.link {
  display: flex;
  align-items: center;
  flex-direction: row;
  cursor: pointer;
  position: relative;
  font-weight: 400;
  user-select: none;

  padding: 1em 1em 1em 0.25em;
  font-size: 12px !important;
  margin-inline-start: 0.5em;
  height: 30px;
  border-radius: 0.25em;

  color: var(--color-text);
  text-decoration: none;
}
.link.top {
  flex-direction: column;

  margin: 0.1em 0;
  padding: 1em .25em;
  border-radius: 0.25em;
  height: 80px;
  min-width: 80px;
}
.link .icon {
  padding: 5px;
  /* font-size: 16px; */
}
.link.top .icon {
  font-size: 22px;
}
.link span {
  font-size: 12px;
}
.link:hover {
  /* background-color: var(--sidebar-item-hover); */
  background-color: rgba(var(--public-rgb), 0.3);
}
.link.active {
  background-color: rgba(var(--public-rgb), 0.6);
}
</style>